export default __webpack_public_path__ + "b580b295c1515fcf68aa1881a1f45184.webm";